export default "__VITE_ASSET__CSbiXVRm__"